import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M26 2C28.1875 2 30 3.8125 30 6V26C30 28.25 28.1875 30 26 30H6C3.75 30 2 28.25 2 26V6C2 3.8125 3.75 2 6 2H26ZM14.5 9.5V17.5C14.5 18.375 15.125 19 16 19C16.8125 19 17.5 18.375 17.5 17.5V9.5C17.5 8.6875 16.8125 8 16 8C15.125 8 14.5 8.6875 14.5 9.5ZM16 25C17.0625 25 17.9375 24.125 17.9375 23.0625C17.9375 22 17.0625 21.125 16 21.125C14.875 21.125 14 22 14 23.0625C14 24.125 14.875 25 16 25Z'],
  name: 'uiExclamationSquareSolid'
} as IconDefinition
